<template>
    <div class="ui-content dashboard user-section user-height">
        <v-card class="mx-auto normal-card autohg">
            <div class="data-table-section" ref="infoBox">
                <v-data-table
                    :headers="headers"
                    fixed-header
                    :items="items"
                    hide-default-header
                    hide-default-footer
                    class="elevation-2 cust-table"
                >
                    <template v-slot:header="{ props: { headers } }">
                        <TableHeader
                            :headers="headers"
                            :onHeaderAction="onHeaderAction"
                            :orderBy="orderBy"
                            :onSortChange="onSortChange"
                        />
                    </template>

                    <template v-slot:body="{ items }">
                        <tbody>
                            <tr v-for="(item, index) in items" :key="index">
                                <td class="check-50">
                                    <div class="check-cust">
                                        <v-checkbox
                                            v-model="item.checked"
                                        ></v-checkbox>
                                    </div>
                                </td>
                                <td>{{ item.name }}</td>
                                <td>{{ item.email }}</td>
                                <td  v-model="showToolTip" :disabled="!buttonHovering" >
									<v-tooltip left  bottom content-class="cust-new-tooltip-top open-top">
										<template  v-slot:activator="{ on }">
                                            <v-hover v-model="buttonHovering">
                                                <span
                                                v-on="on"
                                                depressed
                                                    :class="{
                                                    'text-transform-none': true,
                                                    'btn-center': true,
                                                    'btn-default': true,
                                                }"
											
											>{{getCenter(item.center_data).length< 14 ? getCenter(item.center_data):getCenter(item.center_data).substring(0,15) + '...'}}</span
											>
                                            </v-hover>
											
										</template>
										<span >{{getCenter(item.center_data)}} </span>
										</v-tooltip>
								</td>

                                <td
                                    class="blank-80"
                                    @click="editCoordinatorDialog(item)"
                                >
                                    <v-tooltip
                                        left
                                        content-class="cust-tooltip"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-icon
                                                class="pencil-icon"
                                                v-on="on"
                                                >mdi-pencil</v-icon
                                            >
                                        </template>
                                        <span>Edit Name/Email ID/Center</span>
                                    </v-tooltip>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-data-table>
                <AlertBox
                    width="450px"
                    :onClose="onClose"
                    component="components/coordinator/users/ApprovedUsers/EditCoordinatorDetail"
                    :status="status"
                    :data="selctedUserForEdit"
                />
            </div>
        </v-card>
        <div class="footer-btn">
            <div class="pull-left">
                <v-btn
                    :loading="loading"
                    @click="requestApproveOrDisapproveUser(1)"
                    class="right-btn cust-btn"
                    color="primary"
                    >Approve</v-btn
                >
                <v-btn
                    :loading="loading"
                    @click="requestApproveOrDisapproveUser(-1)"
                    class="right-btn cust-btn"
                    color="primary"
                    >Disapprove</v-btn
                >
            </div>
            <div class="pull-right">
                <Pagination
                    :currentPage="currentPage"
                    :totalPage="totalPages"
                    :onPageChange="onPageChange"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
    name: "UsersCoordinator",
    data() {
        return {
            loading: false,
            items: [],
            orderBy: {
                field: "name",
                order: "ASC",
            },
            currentPage: 1,
            pageSize: 10,
            totalPages: 1,
            status: false,
            selctedUserForEdit: {},
            centers: [],
            buttonHovering: false,
            showToolTip: false
        };
    },
    methods: {
        ...mapActions({
            getSelfSignedUpUsers: "userStore/getSelfSignedUpUsers",
            approveOrDisapproveUser: "userStore/approveOrDisapproveUser",
            getCenters: "centerAndBatchStore/getCenters",
        }),
        requestApproveOrDisapproveUser(status) {
            let user_ids = [];
            if (this.items && this.items.length) {
                user_ids = this.items.filter((i) => i.checked).map((u) => u.id);
                if (!user_ids || user_ids.length < 1) {
                    return this.$toasted.error(`Select atleast one user`);
                }
                let reqData = {
                    role_id: this.roleIds.CO,
                    status: status,
                    user_ids: user_ids,
                };
                this.loading = true;
                this.approveOrDisapproveUser(reqData)
                    .then((response) => {
                        this.loading = false;
                        this.requesGetSelfSignedUpUsers();
                        this.$toasted.success(`Success\n${response.message}`, {
                            icon: "check_circle",
                        });
                    })
                    .catch((err) => {
                        this.loading = false;
                    });
            }
        },
        requesGetSelfSignedUpUsers() {
            let reqData = {
                role_id: this.roleIds.CO,
                is_approved: 0,
                active: 1,
                orderBy: this.orderBy,
                pagination: { page: this.currentPage, pageSize: this.pageSize },
            };
            this.$root.showLoader = true;
            this.getSelfSignedUpUsers(reqData)
                .then((response) => {
                    this.items = response.list.map((u) => {
                        u.checked = false;
                        return u;
                    });
                    this.totalPages = response.pagination.pageCount;
                    this.$root.showLoader = false;
                })
                .catch((err) => {
                    this.$root.showLoader = false;
                });
        },
        onHeaderAction(e) {
            if (e.header && e.header.type === "check") {
                if (e.data) {
                    this.items = this.items.map((u) => {
                        u.checked = e.data.checked;
                        return u;
                    });
                }
            }
        },
        onSortChange() {
            this.requesGetSelfSignedUpUsers();
        },
        onPageChange(e) {
            this.currentPage = e;
            this.requesGetSelfSignedUpUsers();
        },
        getCenter(selectedCenter) {
            let center = [];
            if (selectedCenter && selectedCenter.length) {
                this.centers.map((m) => {
                    if (selectedCenter.find(test => test.center_id == m.value)) {
                        center.push(m.text);
                    }
                });
            }

            return center.join(", ");
        },
        requestGetCenters() {
            this.getCenters()
                .then((response) => {
                    this.loading = false;
                    this.centers = response.map((x) => {
                        let c = {};
                        c.text = x.name;
                        c.value = x.id;
                        return c;
                    });
                })
                .catch((err) => {
                    this.loading = false;
                });
        },
        
        editCoordinatorDialog(user) {
            this.selctedUserForEdit = user;
            this.status = true;
        },
        onClose(data) {
            this.status = data.status;
            if (data.reload) {
                this.requesGetSelfSignedUpUsers();
            }
        },
    },
    mounted() {
        this.requestGetCenters();
        this.requesGetSelfSignedUpUsers();
    },
    watch: {
        buttonHovering (val) {
        
        this.showToolTip = val;
    },


    },
    computed: {
        headers() {
            return [
                {
                    text: "",
                    value: "check",
                    type: "check",
                    class: "check-50",
                    checked: this.isAllUserSelected,
                },

                { text: "Name", value: "name" },
                { text: "Email ID", value: "email" },
                { text: "Center", value: "center_data", hideSort: true },
                { text: "", value: "", type: "blank", class: "blank-80" },
            ];
        },
        isAllUserSelected() {
            if (this.items && this.items.length) {
                let tmpArry = this.items.filter((x) => x.checked);
                if (tmpArry) {
                    return tmpArry.length === this.items.length;
                }
            }
            return false;
        },
    },
};
</script>
